module.exports = __webpack_public_path__ + "static/History_Channel_3D-7e244e272728d0493dec888848c907ee.jpg";